
import { Vue, Component, Watch } from "vue-property-decorator";
import DefaultModal from "@/components/modal/DefaultModal.vue";

@Component({ components: { DefaultModal } })
export default class ButtonQA extends Vue {

	isOpenDetail = false;
	modalWidth = '90%';
	screenWidth: number = 0;
	activeKey = '';
	qaDataList = [
		{ no:'01', quetion: '01. 投保天數是怎麼算？', answer:'我們的投保天數是以一天 24 小時為單位做計算。例如：從 10/20 00:00 到 10/21 00:00 這樣是 1 天。' },
		{ no:'02', quetion: '02. Call in 投保有沒有包含班機延誤和行李遺失？', answer:'班機延誤和行李遺失的服務是屬於旅遊不便險的範疇，目前我們富邦人壽還沒有這類型的商品，如果您有這部分的需求，建議您可以向富邦產險諮詢相關服務，提供您富邦產物保險的客服專線供您諮詢。(0800-009-888)' },
		{ no:'03', quetion: '03. 海外突發疾病醫療是我感冒就有理賠嗎？', answer:'海外突發疾病是保障您在行程出發前 180 天內沒有因為相關病症就診，出國後在國外突然發生病狀需要到醫療機構治療，常見的案例是水土不服、腸胃炎……等。建議您如果真的不幸有這個狀況發生時，麻煩您提供診斷書及收據等書面文件，送到我們專業的理賠部門審核。' },
		{ no:'04', quetion: '04. 可是半年內發生腸胃炎或感冒的機率很大啊！是否就不能投保海外突發疾病住院醫療了？', answer:'我們主要是確認您行程前未抱病出國或是您在國外突發的病狀與出國前就診紀錄的因果關係，如果真的有這個狀況時，您還是可以檢附診斷證明及收據等書面文件申請理賠。同時提醒您，理賠的結果仍要以專業理賠部門人員依條款審核為主。' },
		{ no:'05', quetion: '05. 旅遊不便險是保障什麼？', answer:'旅遊不便險主要是保障班機延誤、行李延誤及行李遺失等，但目前我們富邦人壽還沒有這類型的商品，如果您有這部分的需求，建議您可以向富邦產險諮詢相關服務，提供您富邦產物保險的客服專線供您諮詢。(0800-009-888)' },
		{ no:'06', quetion: '06. 我之前聽別人說有申根保險那是什麼？', answer:'申根保險主要是申根公約國也就是歐洲地區的部分國家，對於到他們國家旅遊的旅客的保險基本要求，因為他們國家的醫療水準相對較高，為了保障旅客的醫療資源，會要求到他們國家旅遊的旅客提供相關商業保險的證明。目前富邦人壽並沒有提供申根保險' },
		{ no:'07', quetion: '07. 為什麼旅遊不便險和申根保險不能再這裡一起投保就好了，其他家都可以你們為什麼不行！', answer:'非常抱歉，因應主管機關規定，我們富邦人壽目前僅能辦理與人身生命相關的保障商品，如果您有這部分的需求，建議您可以向富邦產險諮詢相關服務，提供您富邦產物保險的客服專線供您諮詢。(0800-009-888)' },
		{ no:'08', quetion: '08. 我小孩要跟學校出去參加比賽，這樣可以投保旅平險嗎？', answer:'目前我們富邦人壽對於旅平險投保規定是以"旅遊或出差商旅"為目的才能投保，如果是參加比賽的話，項目須符合其他規訂才可投保，建議撥打客服中心由客服人員先為您確認看看。' },
		{ no:'09', quetion: '09. 我要增加眷屬或變更受益人，該怎麼做？', answer:'要麻煩您填寫專案變更申請書，請洽詢保戶服務專線 0809-001-688，再回傳並來電確認資料是否完整！我們再協助您新增，新增完成後就可以投保了。' },
		{ no:'10', quetion: '10. 我在國外臨時有狀況要怎麼找你們？', answer:'投保完成會主動發送簡訊給您，簡訊的第二則會有我們的海外服務專線 8862-2345-9292。如果您在國外有需要服務，您可以透過這支專線與我們聯繫。' },
		{ no:'11', quetion: '11. 請問要怎麼辦旅遊平安卡？', answer:'請找富邦人壽業務員辦理或親臨富邦人壽保戶服務櫃台辦理。' },
		{ no:'12', quetion: '12. 如果突然飛機延誤，我又沒辦法控制，那段時間不就沒保障？', answer:'如果您已經在飛機上且因為不可抗力因素，保險期間會自動延長至被保險人終止乘客身分為止，延長期限不超過 24 小時前項被保險人以乘客身分搭乘領有載客執照之交通工具；如果是遭遇劫持，在劫持中本契約的保險期間如果已經終止，本保險單自動延長有效期至劫持事故終了。劫持事故終了是指被保險人完全脫離被劫持的狀況。' },
		{ no:'13', quetion: '13. 我有需要英文投保證明，何時可以取得英文投保證明？要怎麼申請呢？', answer:'請洽詢保戶服務專線 0809-001-688，富邦人壽全年無休 24 小時待命為您服務。' },
		{ no:'14', quetion: '14. 我如何辦理投保收據之地址、電話或E-mail變更？', answer:'請洽詢保戶服務專線 0809-001-688，富邦人壽全年無休 24 小時待命為您服務。' },
		{ no:'15', quetion: '15. 出發時還沒收到保費收據是否影響保險效力？', answer:'不影響，只要您完成投保並扣款成功，保單即生效，您會收到投保完成的簡訊或EMAIL。' },
		{ no:'16', quetion: '16. 我還未出發，如何變更或撤銷保單內容？', answer:'欲變更或撤銷請於保險契約生效前完成辦理，倘晚於生效時間辦理者，恕不受理其變更投保內容。' },
		{ no:'17', quetion: '17. 我已出發，如何變更或撤銷保單內容？', answer:'已出發則不可撤銷保單，若欲變更請於保險契約終止前完成辦理，倘晚於終止時間辦理者，恕不受理其變更。可變更下列內容：(a)保險期間之延長：倘申請時間晚於契約終止時間，即無法受理該變更，且不得以新保單投保。(b)保險期間之縮短：須於欲縮短時間前辦理完成。若有此需求，請洽詢保戶服務專線 0809-001-688。' },
		{ no:'18', quetion: '18. 我是否可以延長投保天數？', answer:'可以，延長後之保險期間，不得超過下列之規定：(a)國內旅遊最高投保天數為 30 天，國外旅遊最高投保天數為 180 天。(b)若非連續行程，則須於每一行程開始前分別購買。若有此需求，請洽詢保戶服務專線 0809-001-688。' },
	]

	handleClick() {
		this.isOpenDetail = true
		console.log(this.isOpenDetail);
	}

	// 取得畫面寬度
	mounted() {
		this.screenWidth = document.body.clientWidth;
		window.addEventListener('resize', () => {
			return (() => {
				this.screenWidth = document.body.clientWidth;
			})();
		})
	}

	@Watch('screenWidth')
	modalWidthChange() {
		if (this.screenWidth <= 500) {
			this.modalWidth = '90%';
		} else if (500 < this.screenWidth && this.screenWidth <= 1024) {
			this.modalWidth = '70%';
		} else {
			this.modalWidth = '50%';
		}
	}
}
